module.exports = __webpack_public_path__ + "static/restoring-our-city-bc888506681fe2a778bbbb4f73b4bcaf.jpg";